import { motion } from "framer-motion";
import { Scissors, HeartPulse, Flame, Dumbbell, Bandage, PawPrint } from "lucide-react";

const cases = [
  { icon: Scissors, title: "Cuts & Abrasions", desc: "Everyday nicks, scrapes and grazes sealed in seconds." },
  { icon: HeartPulse, title: "Post-Surgical Wounds", desc: "Gentle protective seal for incisions and sutured sites." },
  { icon: Bandage, title: "Diabetic & Chronic Wounds", desc: "Maintains a moist, antimicrobial healing environment." },
  { icon: Flame, title: "Minor Burns", desc: "Soothes and shields first-degree burns from infection." },
  { icon: Dumbbell, title: "Sports Injuries", desc: "Fast field-side protection for turf burns and blisters." },
  { icon: PawPrint, title: "Veterinary First-Aid", desc: "Safe wound care for pets and animals on the go." },
];

export const UseCases = () => (
  <section id="use-cases" className="py-24 md:py-32 bg-muted/40" data-testid="use-cases-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="mb-14 max-w-2xl"
      >
        <span className="font-monotech text-xs tracking-[0.25em] uppercase text-secondary-foreground/70">
          Where It Helps
        </span>
        <h2 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none text-primary mt-4">
          Use cases
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
        {cases.map((c, i) => {
          const Icon = c.icon;
          return (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className="group border border-border bg-card rounded-3xl p-7 hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
              data-testid={`use-case-${i}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-primary grid place-items-center group-hover:bg-secondary transition-colors duration-300">
                <Icon className="w-5 h-5 text-white group-hover:text-primary transition-colors duration-300" />
              </div>
              <h3 className="font-heading font-bold text-xl text-primary mt-6">{c.title}</h3>
              <p className="text-sm text-text-muted mt-2 leading-relaxed">{c.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
